// src/router.js
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  { path: '/',         redirect: '/map' },
  { path: '/map',      name: 'map',      component: () => import('@/views/MapView.vue'),      meta: { title: 'Kort',          icon: 'map' } },
  { path: '/gardens',  name: 'gardens',  component: () => import('@/views/GardensView.vue'),  meta: { title: 'Haver',         icon: 'gardens' } },
  { path: '/plants',   name: 'plants',   component: () => import('@/views/PlantsView.vue'),   meta: { title: 'Planter',       icon: 'plants' } },
  { path: '/settings', name: 'settings', component: () => import('@/views/SettingsView.vue'), meta: { title: 'Indstillinger', icon: 'settings' } },
  { path: '/profile',  name: 'profile',  component: () => import('@/views/ProfileView.vue'),  meta: { title: 'Profil',        icon: 'user' } },
  { path: '/login',    name: 'login',    component: () => import('@/views/LoginView.vue'),    meta: { title: 'Log ind',     chrome: false, public: true } },
  { path: '/register', name: 'register', component: () => import('@/views/RegisterView.vue'), meta: { title: 'Opret konto', chrome: false, public: true } },
  { path: '/:pathMatch(.*)*', redirect: '/map' },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
});

// Routes shown in the nav bar (public/login pages are excluded)
export const navRoutes = routes.filter(r => r.name && r.meta?.chrome !== false);

// Navigation guard — enforces authentication on all non-public routes.
// The auth store's checkAuth() is called once in App.vue before the first
// navigation; subsequent navigations are fast (store is already populated).
router.beforeEach(async (to) => {
  if (to.meta?.public) return true;

  // Lazy-import to avoid circular deps (store imports api, router is loaded first)
  const { useAuthStore } = await import('@/stores/auth.js');
  const auth = useAuthStore();

  if (!auth.checked) await auth.checkAuth();
  if (!auth.user)    return { name: 'login', query: { next: to.fullPath } };
  return true;
});
